export const Play = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.50817 16C2.19457 16 1.87777 15.9136 1.59297 15.744C1.07777 15.4592 0.792969 14.944 0.792969 14.3712V1.65124C0.792969 1.07844 1.10657 0.537639 1.65057 0.24964C2.22017 -0.0639605 2.87937 -0.0927605 3.42337 0.224039L14.3674 6.56644C14.825 6.82244 15.1386 7.28004 15.1962 7.82404C15.2538 8.33924 15.0522 8.88004 14.6522 9.22564C14.6234 9.25444 14.5946 9.28324 14.5658 9.28324L3.39457 15.7728C3.13537 15.9136 2.82177 16 2.50817 16Z"
      fill="#0019A5"
    />
  </svg>
);
